export default __webpack_public_path__ + "static/media/simonedavico.4f337008.png";